import { render, staticRenderFns } from "./type_set.vue?vue&type=template&id=f06d085a&scoped=true&"
import script from "./type_set.vue?vue&type=script&lang=js&"
export * from "./type_set.vue?vue&type=script&lang=js&"
import style0 from "./type_set.vue?vue&type=style&index=0&id=f06d085a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06d085a",
  null
  
)

export default component.exports